<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p-messages
    *ngIf="submitStatus === enumSubmitStatus.SUCCESS_STATUS"
    severity="info"
  >
    <ng-template pTemplate>
      <img
        aria-label="TRM image"
        title="TRM image"
        alt="TRM image"
        src="../../../../../assets/images/check-circle.webp"
        width="60"
      />
      <div class="ml-2">
        <h5>QUOTE REQUEST SUBMITTED!</h5>
        <p *ngIf="!(isTrinUser$ | async)">
          Your account manager will follow up within two business days.<br />Please
          print this page for your records.
        </p>
      </div>
    </ng-template>
  </p-messages>

  <div class="inside-container">
    <div class="review-title" fxFlexAlign="start" *ngIf="submitStatus === -1">
      <h2
        aria-label="REVIEW QUOTE REQUEST"
        title="REVIEW QUOTE REQUEST"
        class="page-header"
      >
        REVIEW QUOTE REQUEST
      </h2>
      <p>Nearly done! Please ensure all information is accurate.</p>
    </div>

    <form [formGroup]="frmContact">
      <div class="top-part">
        <h4>PRODUCT</h4>
        <label *ngIf="selectedStcc !== undefined">{{
          selectedStcc.description_stcc || selectedStcc
        }}</label>
      </div>
      <div class="middle-part">
        <h4>SELECTED CARS</h4>
        <div class="selected-cars">
          <div class="card" *ngFor="let carDetails of selectedCars">
            <app-quick-view-card
              [displayHead]="true"
              [showSelect]="false"
              [carDetails]="carDetails"
              [displayedAttr]="cardAttrList"
            ></app-quick-view-card>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div
          class="first-row"
          *ngIf="
            selectedCarType != enum_car_type.GONDOLA &&
            selectedCarType != enum_car_type.OPEN_HOPPER
          "
        >
          <div class="left-pnl">
            <h4>
              MECHANICAL OPTIONS
              <a
                aria-label="Edit"
                title="Edit"
                *ngIf="submitStatus === -1"
                (click)="goToStep(enumRequestSteps.MECHANICAL_OPTIONS)"
                style="margin-left: 15px"
                >Edit</a
              >
            </h4>
            <div *ngIf="selectedCarType === enum_car_type.COVERED_HOPPER">
              <div class="inner-panel">
                <div>
                  <label>Lining Requirements</label>
                  <span>{{
                    getString(mechanicalOptions['lining-requirements'])
                  }}</span>
                </div>
                <div>
                  <label>Vibrator Brackets</label>
                  <span>{{
                    getString(mechanicalOptions['vibrator-brackets'])
                  }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="selectedCarType === enum_car_type.GENERAL_SERVICE">
              <div class="inner-panel">
                <div>
                  <label>Loading</label>
                  <span>{{
                    getString(mechanicalOptions['loading-type'])
                  }}</span>
                </div>

                <ng-container
                  *ngFor="let type of mechanicalOptions['loading-type']"
                >
                  <div *ngIf="type.name === 'Manway'">
                    <label>Manway type</label>
                    <span>{{
                      getString(mechanicalOptions['manway-type'])
                    }}</span>
                  </div>
                  <div *ngIf="type.name === 'Liquid Valve'">
                    <label>Liquid valve type</label>
                    <span>{{
                      getString(mechanicalOptions['liquid-valve-type'])
                    }}</span>
                  </div>
                </ng-container>

                <div>
                  <label>Air valve requirements</label>
                  <span>{{
                    getString(mechanicalOptions['air-valve-type'])
                  }}</span>
                </div>
                <div *ngIf="mechanicalOptions['air-valve-type'] != 'None'">
                  <label>Air valve connections</label>
                  <span>{{
                    getString(mechanicalOptions['air-valve-fitting'])
                  }}</span>
                </div>
                <div>
                  <label>Unloading</label>
                  <span>{{
                    getString(mechanicalOptions['unloading-type'])
                  }}</span>
                </div>
                <div
                  *ngIf="mechanicalOptions['unloading-type'] != 'Top Unloading'"
                >
                  <label>BOV detail</label>
                  <span>{{ getString(mechanicalOptions['bov-detail']) }}</span>
                </div>
                <div
                  *ngIf="mechanicalOptions['unloading-type'] != 'Top Unloading'"
                >
                  <label>BOV auxillary valve</label>
                  <span>{{
                    getString(mechanicalOptions['bov-aux-valve'])
                  }}</span>
                </div>
                <div>
                  <label>Platform requirements</label>
                  <span>{{
                    getString(mechanicalOptions['platform-reqs'])
                  }}</span>
                </div>
                <div>
                  <label>Manway cover gasket</label>
                  <span>{{
                    getString(mechanicalOptions['manway-gasket'])
                  }}</span>
                </div>
                <div>
                  <label>Flange gasket</label>
                  <span>{{
                    getString(mechanicalOptions['flange-gasket'])
                  }}</span>
                </div>
                <div>
                  <label>BOV cap gasket</label>
                  <span>{{ getString(mechanicalOptions['bov-gasket']) }}</span>
                </div>
                <div>
                  <label>O-ring</label>
                  <span>{{ getString(mechanicalOptions['o-ring']) }}</span>
                </div>
                <div>
                  <label>Magnetic gauging device</label>
                  <span>{{
                    getString(mechanicalOptions['device-settings'])
                  }}</span>
                </div>
                <div>
                  <label>Thermowell</label>
                  <span>{{
                    getString(mechanicalOptions['need-thermowell'])
                  }}</span>
                </div>
                <div>
                  <label>Sample line</label>
                  <span>{{
                    getString(mechanicalOptions['need-sample_line'])
                  }}</span>
                </div>
                <div>
                  <label>Special requirements</label>
                  <span>{{
                    getString(mechanicalOptions['special-reqs'])
                  }}</span>
                </div>
                <div>
                  <label>Lining type</label>
                  <span>{{ getString(mechanicalOptions['lining-type']) }}</span>
                </div>
                <div>
                  <label>Interior Prep</label>
                  <span>{{
                    getString(mechanicalOptions['interior-prep'])
                  }}</span>
                </div>
                <div>
                  <label>Interior Surface Prep</label>
                  <span>{{
                    getString(mechanicalOptions['interior_surface_prep'])
                  }}</span>
                </div>
                <div>
                  <label>Oxygen content</label>
                  <span>{{
                    getString(mechanicalOptions['oxygen-content'])
                  }}</span>
                </div>
                <div>
                  <label>Nitrogen PSI</label>
                  <span>{{
                    getString(mechanicalOptions['nitrogen-psi'])
                  }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="selectedCarType === enum_car_type.PRESSURE_TANK">
              <div class="inner-panel">
                <div>
                  <label>Magnetic gauging device</label>
                  <span>{{
                    getString(mechanicalOptions['device-settings'])
                  }}</span>
                </div>
                <div>
                  <label>Thermowell</label>
                  <span>{{
                    getString(mechanicalOptions['need-thermowell'])
                  }}</span>
                </div>
                <div>
                  <label>Sample line</label>
                  <span>{{
                    getString(mechanicalOptions['need-sample-line'])
                  }}</span>
                </div>
                <div>
                  <label>Flange gasket</label>
                  <span>{{
                    getString(mechanicalOptions['flange-gasket'])
                  }}</span>
                </div>
                <div>
                  <label>O-ring</label>
                  <span>{{
                    getString(mechanicalOptions['o-ring-required'])
                  }}</span>
                </div>
                <div>
                  <label>Interior Prep</label>
                  <span>{{
                    getString(mechanicalOptions['interior-prep'])
                  }}</span>
                </div>
                <div>
                  <label>Oxygen content</label>
                  <span>{{
                    getString(mechanicalOptions['oxygen-content'])
                  }}</span>
                </div>
                <div>
                  <label>Nitrogen PSI</label>
                  <span>{{
                    getString(mechanicalOptions['nitrogen-psi'])
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right-pnl">
            <h4>
              LEASE DETAILS
              <a
                aria-label="Edit"
                title="Edit"
                *ngIf="submitStatus === -1"
                (click)="goToStep(enumRequestSteps.LEASING_OPTIONS)"
                style="margin-left: 15px"
                >Edit</a
              >
            </h4>
            <div class="inner-panel">
              <div>
                <label>Lease Type</label>
                <span>{{
                  getString(final['lease-details']['preferred-lease-type'])
                }}</span>
              </div>
              <div>
                <label>Preferred Lease Term</label>
                <span>{{
                  getString(
                    final['lease-details']['preferred-lease-term'],
                    'preferred-lease-term'
                  )
                }}</span>
              </div>
              <div>
                <label>Railcar Quantity</label>
                <span
                  >{{ final['lease-details']['min'] }} -
                  {{ final['lease-details']['max'] }}</span
                >
              </div>
              <div>
                <label>Loading Location</label>
                <div class="multi-rows">
                  <span
                    style="margin-bottom: 0px"
                    *ngIf="final['lease-details']['city'] != ''"
                    >{{ final['lease-details']['city'] }}</span
                  >
                  <span style="margin-bottom: 0px">{{
                    final['lease-details']['state']
                  }}</span>
                  <span>{{ final['lease-details']['country'] }}</span>
                </div>
              </div>
              <div>
                <label>Preferred Rail Carrier</label>
                <span>{{
                  getString(
                    final['lease-details']['preferred-rail-carrier'],
                    'preferred-rail-carrier'
                  )
                }}</span>
              </div>
              <div>
                <label>Rail Service</label>
                <span>{{
                  getString(final['lease-details']['rail-service-type'])
                }}</span>
              </div>
              <div>
                <label>Date Needed</label>
                <span
                  >{{
                    final['lease-details']['leaseableDate'] | date: 'MM/dd/yyyy'
                  }}
                  <i *ngIf="final['lease-details']['flexableDate']"
                    >, Flexible</i
                  ></span
                >
              </div>
              <div>
                <label>Trinsight</label>
                <span>{{
                  final['lease-details']['trinSight'] ? 'Yes' : 'No'
                }}</span>
              </div>
              <div>
                <label>SDS</label>
                <div class="multi-rows">
                  <span>{{
                    final['lease-details']['sds-available'] | titlecase
                  }}</span>
                  <span
                    *ngFor="let file of final['lease-details']['sds']"
                    title="{{ file['sds_name'] }}"
                    style="color: #676b6f"
                  >
                    {{
                      file.sds_name.length > 21
                        ? (file.sds_name | slice: 0 : 21) + '...'
                        : file.sds_name
                    }}
                  </span>
                </div>
              </div>
              <div *ngIf="final['lease-details']['comments'] !== ''">
                <label>Additional Information</label>
                <span style="word-wrap: break-word">{{
                  final['lease-details']['comments']
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="second-row">
          <h4>
            CONTACT
            <i
              class="pi pi-info-circle"
              [escape]="false"
              pTooltip="<h6>Contact Information</h6><p>Is your information incomplete or incorrect? Please let your account manager know.</p>"
              tooltipPosition="right"
            ></i>
          </h4>
          <div
            class="inner-panel"
            *ngIf="clientData && clientData !== undefined"
          >
            <div
              class="first-column"
              *ngIf="clientData['contact-info'] !== undefined"
            >
              <label>{{ clientData['contact-info'].name }}</label>
              <span>{{ clientData['contact-info'].email }}</span>
              <span>{{ clientData['contact-info'].phone }}</span>
            </div>
            <div
              class="second-column"
              *ngIf="clientData['company-info'] !== undefined"
            >
              <label>{{ clientData['company-info'].name }}</label>
              <span>{{ clientData['company-info'].address.street }}</span>
              <span
                >{{ clientData['company-info'].address.city }},
                {{ clientData['company-info'].address.state }}</span
              >
              <span
                >{{
                  clientData['company-info'].address.country !== null
                    ? clientData['company-info'].address.country
                    : ''
                }}
                {{ clientData['company-info']['address']['postal-code'] }}</span
              >
            </div>
            <div class="third-column">
              <label style="margin-bottom: 0px"
                >Alternative Phone #<i
                  *ngIf="submitStatus !== enumSubmitStatus.SUCCESS_STATUS"
                  >Optional</i
                ></label
              >
              <span style="display: inline-block">
                <p-dropdown
                  [options]="CountryCodeOptions"
                  ngDefaultControl
                  class="phone"
                  name="country_code"
                  formControlName="country_code"
                  [ngClass]="{
                    'phone-filled':
                      validatePhone() && frmContact.value.area_code !== ''
                  }"
                  optionValue="value"
                  optionLabel="label"
                >
                  <ng-template let-item pTemplate="item">
                    <div>{{ item.label }}</div>
                  </ng-template>
                </p-dropdown>
                <input
                  type="text"
                  [OnlyNumber]="true"
                  [maxDigits]="10"
                  [minlength]="10"
                  pInputText
                  (focus)="hidePhonePlaceholder()"
                  (blur)="showPhonePlaceholder()"
                  name="phone_no"
                  style="width: 60%"
                  formControlName="phone_no"
                  [ngClass]="{
                    filled: validatePhone() && frmContact.value.phone_no !== ''
                  }"
                />
                <label
                  class="phone-placeholder"
                  (click)="hidePhonePlaceholder()"
                  *ngIf="!isPhonePlaceholderHidden"
                  >Phone #</label
                >
              </span>
              <div
                class="alert-str"
                *ngIf="
                  frmContact.controls['phone_no'].invalid &&
                  (frmContact.controls['phone_no'].touched ||
                    frmContact.controls['phone_no'].dirty)
                "
              >
                <small
                  class="p-error block"
                  *ngIf="
                    frmContact.controls['phone_no'].hasError('minlength') ||
                    !validatePhone()
                  "
                  >Phone number should be 10 digits long.</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div
      class="btn-panel"
      *ngIf="submitStatus === -1"
      id="div_btn-panel_e55b533a"
    >
      <p id="p_a5105287">
        By submitting this request for a quote, I authorize TrinityRail® to
        prepare a quote and to contact me via email or phone. I understand
        displayed pricing and inventory is not guaranteed, is subject to change,
        and that submitting a request for a quote does not constitute a contract
        with TrinityRail®.
      </p>
      <div id="div_bc92ce03">
        <button
          class="back-button"
          (click)="back()"
          id="button_back-button_31d033f2"
        >
          <i class="pi pi-angle-left" id="i_pi_324e3b97"></i>
        </button>
        <button
          class="next-button"
          id="btn-submit"
          (click)="submit()"
          [disabled]="!frmContact.valid || !validatePhone()"
        >
          SUBMIT
        </button>
      </div>
    </div>
  </div>
</div>

<div class="progress-spinner" *ngIf="loading">
  <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
</div>
